import React from 'react'
import { Helmet } from 'react-helmet'
import FooterBar from 'components/FooterBar'
import ManageRooms from './ManageRooms'
import { RoomsContainer } from './styles'
import HotelOverview from './HotelOverview'

const Cafe = () => {

  return (
    <>
      <Helmet>
        <title>Cafe - Rook Hotel PMS</title>
        <meta name="description" content="Cafe - Rook Hotel PMS" />
      </Helmet>
      <RoomsContainer>
        <HotelOverview />
        <ManageRooms />
      </RoomsContainer>
      <FooterBar />
    </>
  );
};

export default Cafe;
